module.exports = __webpack_public_path__ + "static/img/menu-product-kegel.82cb8002.png";